module.exports = __webpack_public_path__ + "static/media/12UNCTAD7.c3ed6b2c.jpg";